import Http from '@/api/http.js'

export default {
  index(params){
    return Http.get(`/client_block_logs`, {
      params
    });
  },
}